import {
  TripsSortOptions,
  type TripsSortValue,
} from "@/features/trips/types/types";
import { SortOrder } from "@/types/enums";

export const initialSortValue: TripsSortValue = {
  field: TripsSortOptions.POSITION,
  order: SortOrder.ASC,
};
